import React from "react";
import { Helmet } from "react-helmet-async";
import "./AboutUs.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

const AboutUs = () => {
  return (
    <>
      {/* ================= SEO META TAGS ================= */}
      <Helmet>
        <title>Trusted Diagnostic Hospital in Mohali | Tricity Imaging & Lab Services | Kior Healthcare</title>

        <meta
          name="description"
          content="Looking for a trusted diagnostic hospital in Mohali? NABL certified labs, advanced medical tests & best pathology lab services. Book your test today."
        />

        <meta
          name="keywords"
          content="Health Care Diagnostic Center in Mohali, Ultrasound Centre in Mohali, Hospital Laboratory Near Me, Scan Centre, Sonography Clinic"
        />

        <meta
          property="og:title"
          content="Trusted Diagnostic Hospital in Mohali | Tricity Imaging & Lab Services | Kior Healthcare"
        />
        <meta
          property="og:description"
          content="Kior Healthcare is a trusted diagnostic Hospital in Mohali offering MRI, CT Scan, X-Ray, Ultrasound, and pathology services across Tricity. Accurate reports, advanced technology, and patient-focused care. Book your test today."
        />
        <meta property="og:type" content="website" />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ================= BANNER ================= */}
      <section className="banner-section">
        <div className="banner_img">
          <img
            src="/images/aboutUs.jpeg"
            alt="Kior Healthcare Diagnostic Center Mohali"
            className="img-fluid w-100"
          />
        </div>
      </section>

      {/* ================= BREADCRUMB ================= */}
      <section className="brudcrum-sec py-3">
        <div className="coustom_container">
          <div className="aboutus_brudcrums d-flex align-items-center gap-2 flex-wrap">
            <Link
              to="/"
              className="previous_pg d-flex align-items-center text-decoration-none text-dark"
            >
              <ArrowBackIosIcon fontSize="small" />
              <span>Home</span>
            </Link>
            <span>/</span>
            <Link to="/about-us" className="text-decoration-none text-primary">
              <span>About Us</span>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= ABOUT DESCRIPTION ================= */}
      <section className="about_description py-5">
        <div className="coustom_container">
          <h1 className="mb-3">
            About Kior Healthcare – Trusted Diagnostic Hospital in Mohali
          </h1>

          <p>
            Kior Healthcare is one of the leading diagnostic hospitals in
            Mohali, committed to delivering accurate, timely, and high-quality
            diagnostic services using advanced medical technology. Being the
            contemporary diagnostic centre in Mohali and Tricity region, we
            specialise in early detection of disease with available testing
            services and facilities all under one roof. Our centre - to offer
            compassionate, accurate and clinically excellent diagnostic imaging
            and laboratory services that meet the highest international
            standards. Recognised among leading diagnostic providers in the
            region, Kior Healthcare offers a comprehensive range of imaging and
            pathology services. We have the most advanced Diagnostic systems
            available for our patients and doctors, including MRI, CT Scan (with
            cardiac imaging), Digital X-Ray, Mammography, Ultrasound & Colour
            Doppler, as well as fully computerised lab testing.
          </p>

          <h2 className="mt-4">Our Vision</h2>
          <p>
            Our vision is to establish Kior Healthcare as one of the most
            reliable and advanced diagnostic centres in Mohali and Punjab, where
            clinical accuracy, ethical medical practice, and compassionate
            patient care are given equal importance.
          </p>

          <h2 className="mt-4">Our Mission</h2>

          <p>
            Our mission is to provide precise, timely, and dependable diagnostic
            reports using advanced technology, standardized quality protocols,
            and experienced medical professionals, helping doctors make
            confident clinical decisions and improving patient health outcomes.
          </p>
          <h2 className="mt-4">Our Founders & Establishment</h2>

          <p>
            Kior Healthcare was established on 10th November 2022 under the
            leadership of <strong>Dr. Sunil Sharma</strong> and <strong>Dr. Vandita Sharma (MD
            Radiology)</strong>, Founders & Medical Directors. Since its establishment,
            the centre has focused on maintaining high diagnostic standards,
            patient trust, and continuous quality improvement aligned with
            national healthcare benchmarks. As one of the preferred 
            <strong> NABL-standard</strong> quality and best pathology lab options in Mohali, we
            follow strict quality protocols and standardized testing processes.
            Our experienced radiologists, technicians, and lab professionals
            work together to maintain high accuracy in every report. Kior
            Healthcare is dedicated to making medical tests in Mohali
            accessible, affordable, and patient-friendly. We proudly serve
            patients searching for a diagnostic centre near me, including those
            from Chandigarh, Panchkula, and across Punjab. At <strong>Kior Healthcare</strong>,
            we believe accurate diagnosis is the foundation of effective
            treatment and better health outcomes.
          </p>

          <h4 className="mt-4">Our Services</h4>
          <Row className="mt-3">
            <Col md={6}>
              <h6>Pathology & Laboratory Services</h6>
              <ul>
                <li>Comprehensive blood tests</li>
                <li>Hormonal analysis</li>
                <li>Organ function testing</li>
                <li>Preventive health packages</li>
                <li>Specialized panels for diabetes, thyroid & anemia</li>
              </ul>
            </Col>

            <Col md={6}>
              <h6>Imaging & Scan Services</h6>
              <ul>
                <li>X-Ray and CT Scan (Scan Centre)</li>
                <li>Ultrasound & Sonography (Sonography Clinic)</li>
                <li>Digital radiology solutions</li>
                <li>Prenatal & gynecological imaging</li>
              </ul>
            </Col>
          </Row>

          <h4 className="mt-4">Why Choose Kior Healthcare?</h4>
          <ul>
            <li>Accurate and reliable reports using advanced technology</li>
            <li>Complete diagnostic solutions under one roof</li>
            <li>Experienced technicians and medical professionals</li>
            <li>Fast reports with digital access</li>
            <li>Trusted ultrasound and scan services in Mohali</li>
            <li>Conveniently located hospital laboratory near you</li>
          </ul>

          <p className="mt-3">
            At Kior Healthcare, we are dedicated to providing diagnostic
            services patients can trust—supporting your health journey with
            precision, care, and compassion.
          </p>
        </div>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="aboutUs_vision_mission py-5">
        <div className="coustom_container">
          <Row className="gy-4">
            <Col md={6}>
              <div className="aboutus_vision text-center">
                <img
                  src="/images/OUR-VISION-icon.webp"
                  alt="Vision"
                  className="mb-3"
                />
                <h4 className="fw-bold">OUR VISION</h4>
                <p>
                  To be the most trusted and patient-friendly diagnostic center
                  in Mohali, recognized for quality, innovation, and compassion.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <div className="aboutus_mission text-center">
                <img
                  src="/images/OUR-MISSION-icon.webp"
                  alt="Mission"
                  className="mb-3"
                />
                <h4 className="fw-bold">OUR MISSION</h4>
                <p>
                  To deliver timely, accurate, and accessible diagnostic
                  services using advanced technology and expert care to empower
                  better medical decisions.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* ================= TEAM ================= */}
      <section className="our_team py-5 bg-primary">
        <div className="coustom_container">
          <Row className="align-items-center">
            <Col md={4} className="text-center">
              <img
                src="/images/ourteam_img.png"
                alt="Kior Healthcare Team"
                className="img-fluid"
              />
            </Col>

            <Col md={8} className="text-white">
              <h1>Our Team</h1>
              <p>
                Kior Healthcare is powered by experienced pathologists,
                radiologists, technicians, and phlebotomists trained at premier
                institutes like PGI. Our interdisciplinary team works together
                to ensure accuracy, safety, and excellence in diagnostics.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* ================= VALUES ================= */}
      <section className="values_section py-5">
        <div className="text-center mb-4">
          <h1>Our Values</h1>
        </div>

        <div className="coustom_container">
          <Row className="gy-4">
            {[
              ["C", "COLLABORATION", "Working together to deliver excellence"],
              ["A", "AGILITY", "Adapting quickly with innovative diagnostics"],
              ["R", "RESPECT", "Treating every patient with dignity"],
              ["E", "EMPATHY", "Caring deeply about patient well-being"],
              ["S", "OWNERSHIP", "Taking responsibility for quality and trust"],
            ].map(([l, t, d], i) => (
              <Col md={4} sm={6} key={i}>
                <div className="alphabet_card text-center p-4 shadow h-100">
                  <h1>{l}</h1>
                  <h6>{t}</h6>
                  <p>{d}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
